var exports = {
  "UT": "MenuItems.module__roleIcon___UW05Tl",
  "yk": "MenuItems.module__roleContainer___UW05Tl",
  "S3": "MenuItems.module__roleName___UW05Tl",
  "nT": "MenuItems.module__roleDisabled___UW05Tl",
  "u8": "MenuItems.module__readonlyRoleItem___UW05Tl",
  "zQ": "MenuItems.module__readonlyRoleSpacer___UW05Tl",
  "ec": "MenuItems.module__flexColumn___UW05Tl",
  "Kk": "MenuItems.module__icon___UW05Tl",
  "Bx": "MenuItems.module__iconSmall___UW05Tl",
};

module.exports = exports;
